import * as actionTypes from "../actions/actionTypes";

const initialState: {
  provider: {
    providerId: string;
    providerName: string;
    providerEntityType: string;
    providerLabels: string[];
    longitude: number;
    latitude: number;
    address: string;
    city: string;
    state: string;
    hospitalName: string;
    postalCode: string;
    phoneNumber: string;
    providerType: string;
    specialty: string;
    isContracted: boolean;
    favoriteId: string;
    isFavorite: boolean;
    totalExperienceScore: number;
    distance: number;
    gender: string;
    experienceScore: {
      label: string;
      value: number;
    }[];
    qualityScore: {
      label: string;
      value: number;
    }[];
    quantrosScores: {
      category: string;
      scores: { name: string; order: number; score: number }[];
    }[];
    finderLabel: string;
    additionalLocations: {
      addressId: number;
      addressTypeId: number;
      id: number;
      address:{
        addressLine1: string;
        addressLine2: string;
        city: string;
        latitude: number;
        longitude: number;
        postalCode: string;
        state: string;
      }[]
    }[];
    additionalLocationsCount: number;
  };
  error: boolean;
  loading: boolean;
} = {
  provider: {
    providerId: "",
    providerName: "",
    providerEntityType: "",
    providerLabels: [""],
    longitude: 0,
    latitude: 0,
    address: "",
    city: "",
    state: "",
    hospitalName: "",
    postalCode: "",
    phoneNumber: "",
    providerType: "",
    specialty: "",
    isContracted: true,
    favoriteId: "",
    isFavorite: true,
    totalExperienceScore: 0,
    distance: 0,
    gender: "",
    experienceScore: [
      {
        label: "",
        value: 0,
      },
    ],
    qualityScore: [
      {
        label: "",
        value: 0,
      },
    ],
    quantrosScores: [],
    finderLabel: "",
    additionalLocations: [],
    additionalLocationsCount: 0,
  },
  error: false,
  loading: false,
};
const providerDetails = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PROVIDER_DETAILS_START: {
      return {
        ...state,
        provider: initialState.provider,
        error: false,
        loading: true,
      };
    }
    case actionTypes.FETCH_PROVIDER_DETAILS_SUCCESS: {
      return {
        ...state,
        provider: action.provider ? action.provider : initialState.provider,
        error: false,
        loading: false,
      };
    }
    case actionTypes.FETCH_PROVIDER_DETAILS_FAILED: {
      return {
        ...state,
        provider: initialState.provider,
        error: true,
        loading: false,
      };
    }
    default:
      return state;
  }
};
export default providerDetails;
